import {
  SELECT_SEASON,
} from './constants'

export function updateCurrentSeason (payload) {
  return {
    type: SELECT_SEASON,
    payload,
  }
}
